import { InfoDialog } from "../../bottom-navigation-panel";
import { ControlType, FormField, FormFieldInit } from "./base";

export class FormFieldRadio extends FormField {
  public override controlType = ControlType.RADIO;

  public options: RadioButtonOption[];
  public variant?: "radio" | "button";

  constructor(init: FormFieldInit<FormFieldRadio>) {
    super(init);
    this.options = init.options;
    this.variant = init.variant ?? "radio";
  }
}

export interface RadioButtonOption {
  id: string;
  value: string | number | boolean;
  label: string;
  description?: string;
  containerClassName?: string;
  labelClassName?: string;
  disabled?: boolean;
  infoDialog?: InfoDialog;
}
